<template>
  <layout-container>

    <template slot="left">

      <tooltip-container v-if="areValuesPristine" boundary="window">
        <rb-button-with-material-icon @click="acceptOffer">
          <template slot="icon">check_circle</template>
          Accept Supplier Offer
        </rb-button-with-material-icon>

        <span slot="tooltip">Finalize negotiations by accepting the last supplier offer</span>
      </tooltip-container>

      <tooltip-container v-if="areValuesPristine" boundary="window">
        <rb-button-with-material-icon @click="finalizeWithRequest">
          <template slot="icon">check_circle</template>
          Finalize With Last Request
        </rb-button-with-material-icon>

        <span slot="tooltip">Finalize negotiations by accepting rates and amenities from the negotiation request</span>
      </tooltip-container>

      <the-negotiations-form-button-finalize-with-entered v-if="areValuesDirty" @click="finalizeWithModel"/>

    </template>

    <rbButton v-on:click="cancel">Cancel</rbButton>

    <rb-button-with-material-icon :disabled="isInputPristine" @click="update" type="main">
      <template slot="icon">send</template>
      Resubmit Negotiation Request
    </rb-button-with-material-icon>

  </layout-container>
</template>

<script>
  import TheNegotiationsFormButtonsMixin from './TheNegotiationsFormButtonsMixin.vue';
  import TheNegotiationsFormButtonFinalizeWithEntered from './TheNegotiationsFormButtonFinalizeWithEntered.vue';

  export default {
    name: 'negotiations-form-buttons-for-buyer-editing-request',

    mixins: [ TheNegotiationsFormButtonsMixin ],

    components: { TheNegotiationsFormButtonFinalizeWithEntered }
  };
</script>
